import {
  Select as AntdSelect,
  SelectProps as AntdSelectProps,
  Spin
} from 'antd'
const { Option } = AntdSelect
interface SelectProps extends AntdSelectProps<any> {
  label?: string
}

export const Select = (props: SelectProps) => {
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {label && (
        <div style={{ width: 200, justifyItems: 'flex-end' }}>
          <span>{label}:</span>
        </div>
      )}
      <div style={{ width: '100%' }}>
        <AntdSelect {...props}>
          {props.loading && (
            <Option key="loading" value="loading" disabled>
              <div style={{ textAlign: 'center', padding: '4px' }}>
                <Spin tip="Carregando..." style={{ background: '#fff' }} />
              </div>
            </Option>
          )}

          {props.children}
        </AntdSelect>
      </div>
    </div>
  )
}

Select.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
